import { PackageOptionUpgradeView } from 'components/OfferPage/PackageUpgrade/PackageUpgradeModal'

function getPackageUpgradePrice(packageUpgrade: PackageOptionUpgradeView, hasFlightsSelected?: boolean) {
  const totalPrice = packageUpgrade.price + packageUpgrade.package.propertyFees
  const totalPriceWithFlights = hasFlightsSelected && packageUpgrade.flightPrice && packageUpgrade.flightsAvailable ? totalPrice + packageUpgrade.flightPrice : totalPrice
  const totalMemberPrice = packageUpgrade.memberPrice + packageUpgrade.package.propertyFees
  const totalMemberPriceWithFlights = hasFlightsSelected && packageUpgrade.flightPrice && packageUpgrade.flightsAvailable ? totalMemberPrice + packageUpgrade.flightPrice : totalMemberPrice

  const isSamePrice = totalPrice === totalMemberPrice
  const total = !isSamePrice && packageUpgrade.memberPriceDifference > 0 ? totalMemberPriceWithFlights : totalPriceWithFlights

  return {
    total,
    isSamePrice,
    price: packageUpgrade.priceDifference,
    memberPrice: packageUpgrade.memberPriceDifference,
    duration: packageUpgrade.package.duration,
  }
}

export default getPackageUpgradePrice
